export default {
      id: "link-usage",
      viewBox: "0 0 10 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#link",
      toString: function () {
        return this.url;
      }
    }